import {
  beSMSSendGetSenderStatus,
  TRUSTED_SENDER_STATUS_NOT_CONFIRMED
} from 'Api/beSMSSendApi'

async function fetchStatus(SenderNumber) {
  const result = await beSMSSendGetSenderStatus(SenderNumber)

  return result !== null ? result.Status : TRUSTED_SENDER_STATUS_NOT_CONFIRMED
}

export default fetchStatus
